define('TescoMobile_DynamicBundleOptions/js/dynamic-options/model/url-builder',['jquery'], function ($) {
  'use strict';

  return {
    method: 'rest',
    version: 'V1',
    serviceUrl: ':method/:version',
    createUrl: function (url, params) {
      var completeUrl = this.serviceUrl + url;
      return this.bindParams(completeUrl, params);
    },
    bindParams: function (url, params) {
      var urlParts;
      params.method = this.method;
      params.version = this.version;
      urlParts = url.split('/');
      urlParts = urlParts.filter(Boolean);
      $.each(urlParts, function (key, part) {
        part = part.replace(':', '');
        if (params[part] != undefined) {
          urlParts[key] = params[part];
        }
      });
      return urlParts.join('/');
    }
  };
});

